import { Link } from 'react-router-dom';
import Logo from '../assets/logo.svg';
import DashboardMockup from '../assets/dashboard-mockup.png';
import ChartDetailMockup from '../assets/chart-detail-mockup.png';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Custom Landing Navbar */}
      <header className="landing-header">
        <div className="landing-nav-container">
          <div className="landing-logo">
            <Link to="/">
              <img src={Logo} alt="Valuera Logo" className="logo-img" />
            </Link>
          </div>
          <nav className="landing-nav-links">
            <a href="#features" className="landing-nav-link">
              Features
            </a>
            <Link to="/pricing" className="landing-nav-link">
              Kosten
            </Link>
            <a href="#kontakt" className="landing-nav-link">
              Kontakt
            </a>
            <Link to="/login" className="landing-nav-link">
              Einloggen
            </Link>
            <Link to="/register" className="landing-cta-nav-btn">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="btn-plus-icon"
              >
                <circle cx="8" cy="8" r="7.5" stroke="currentColor" />
                <path
                  d="M8 5V11M5 8H11"
                  stroke="currentColor"
                  strokeLinecap="round"
                />
              </svg>
              <span>Kostenlos anmelden</span>
            </Link>
          </nav>
        </div>
      </header>

      <main className="landing-main">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">
              Behalte dein gesamtes
              <br />
              Immobilienportfolio im Griff
            </h1>
            <p className="hero-subtitle">
              Valuera vereint intelligentes Portfolio-Management mit
              zertifizierten Immobilienbewertungen. Zentral, transparent und
              jederzeit aktuell.
            </p>
            <div className="hero-ctas">
              <Link to="/register" className="cta-button-solid">
                Jetzt kostenlos starten
              </Link>
              <a href="#features" className="cta-button-outline">
                Mehr erfahren
              </a>
            </div>
          </div>

          {/* Hero Dashboard Preview */}
          <div className="hero-mockup-container">
            <div className="hero-mockup-glow" />
            <img
              src={DashboardMockup}
              alt="Valuera Dashboard Mockup"
              className="hero-mockup-img"
            />
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="features-section">
          <div className="section-intro">
            <div className="section-badge">
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="badge-icon"
              >
                <path
                  d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                  fill="currentColor"
                />
              </svg>
              <span>Features</span>
            </div>
            <h2 className="section-title">
              Dein Immobilienportfolio.
              <br />
              Professionell gemanagt.
            </h2>
          </div>

          <div className="features-grid">
            {/* Feature Row 1 */}
            <div className="feature-row">
              <div className="feature-graphic">
                <div className="graphic-glass-card">
                  <img
                    src={ChartDetailMockup}
                    alt="Gesamtwert & Wertentwicklung"
                    className="feature-mockup-img"
                  />
                </div>
              </div>
              <div className="feature-text">
                <div className="feature-badge">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="badge-icon"
                  >
                    <path
                      d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>Gesamtwert & Wertentwicklung</span>
                </div>
                <h3 className="feature-title">Wissen, was dein Portfolio wert ist.</h3>
                <p className="feature-description">
                  Verfolge den Wert deiner Immobilien und ihre Entwicklung – für einzelne Objekte und dein gesamtes Portfolio.                </p>
              </div>
            </div>

            {/* Feature Row 2 (Reversed) */}
            <div className="feature-row feature-row-reverse">
              <div className="feature-graphic">
                <div className="graphic-glass-card">
                  <div className="finance-mockup-inner">
                    <div className="finance-mockup-header">
                      <span>Finanzen</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="2"
                          y="5"
                          width="20"
                          height="14"
                          rx="2"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                        <circle
                          cx="12"
                          cy="12"
                          r="3"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                    <div className="finance-mockup-grid">
                      <div className="finance-item">
                        <span className="finance-label">Eigenkapital</span>
                        <span className="finance-value">455.000 €</span>
                      </div>
                      <div className="finance-item">
                        <span className="finance-label">Fremdkapital</span>
                        <span className="finance-value">400.000 €</span>
                      </div>
                      <div className="finance-item">
                        <span className="finance-label">
                          Monatliche Fixkosten
                        </span>
                        <span className="finance-value">1.484,95 €</span>
                      </div>
                      <div className="finance-item">
                        <span className="finance-label">
                          Empfohlene Instandhaltungsrücklagen
                        </span>
                        <span className="finance-value">190.000 €</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="feature-text">
                <div className="feature-badge">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="badge-icon"
                  >
                    <path
                      d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>Finanzen</span>Gesamtwert & Wertentwicklung
                </div>
                <h3 className="feature-title">Deine Finanzen auf einen Blick.</h3>
                <p className="feature-description">
                  Behalte Eigen- und Fremdkapital, laufende Kosten und wichtige Finanzkennzahlen deines Portfolios zentral im Überblick.                </p>
              </div>
            </div>

            {/* Feature Row 3 */}
            <div className="feature-row">
              <div className="feature-graphic">
                <div className="graphic-glass-card graphic-glass-card-compact">
                  <div className="summary-mockup-inner">
                    <div className="summary-mockup-card">
                      <span className="summary-label">
                        Gesamtzahl der Immobilien
                      </span>
                      <span className="summary-value">3</span>
                    </div>
                    <div className="summary-mockup-card">
                      <span className="summary-label">Gesamtrendite</span>
                      <span className="summary-value positive">+331.711 €</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="feature-text">
                <div className="feature-badge">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="badge-icon"
                  >
                    <path
                      d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>Rendite & Performance</span>
                </div>
                <h3 className="feature-title">Verstehe, wie dein Portfolio performt.</h3>
                <p className="feature-description">
                  Sieh auf einen Blick, wie sich Wertentwicklung und Mieteinnahmen auf die Rendite deines Immobilienportfolios auswirken.                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Middle CTA Section */}
        <section className="cta-box-section">
          <div className="cta-box">
            <h2 className="cta-box-title">
              Ein Ort für alles. Ein Tool für deine Immobilien.
            </h2>
            <p className="cta-box-text">
              Valuera bündelt Immobilien, Bewertungen und Dokumente auf einer
              zentralen Plattform – für mehr Übersicht und fundierte
              Entscheidungen.
            </p>
            <Link to="/register" className="cta-box-btn">
              <span>Jetzt kostenlos starten</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="btn-arrow-icon"
              >
                <path
                  d="M7 17L17 7M17 7H9M17 7V15"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <div className="section-intro">
            <div className="section-badge">
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="badge-icon"
              >
                <path
                  d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                  fill="currentColor"
                />
              </svg>
              <span>Benefits</span>
            </div>
            <h2 className="section-title">
              Dein gesamtes Immobilienportfolio. Klar, strukturiert und
              jederzeit griffbereit.
            </h2>
          </div>

          <div className="benefits-grid">
            {/* Benefit Cards 1-6 */}
            <div className="benefit-card">
              <div className="benefit-icon-badge">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="badge-icon"
                >
                  <path
                    d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h3 className="benefit-card-title">Alles auf einen Blick</h3>
              <p className="benefit-card-description">
                Alle Immobilien und die wichtigsten Kennzahlen deines Portfolios übersichtlich an einem Ort.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon-badge">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="badge-icon"
                >
                  <path
                    d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h3 className="benefit-card-title">Wertentwicklung verfolgen</h3>
              <p className="benefit-card-description">
                Verfolge, wie sich der Wert einzelner Immobilien und deines gesamten Portfolios entwickelt.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon-badge">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="badge-icon"
                >
                  <path
                    d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h3 className="benefit-card-title">Finanzen im Blick behalten</h3>
              <p className="benefit-card-description">
                Behalte Eigenkapital, Fremdkapital, laufende Kosten und weitere Finanzkennzahlen zentral im Blick.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon-badge">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="badge-icon"
                >
                  <path
                    d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h3 className="benefit-card-title">
                Dokumente zentral verwalten
              </h3>
              <p className="benefit-card-description">
                Ordne Verträge, Pläne, Energieausweise und weitere Unterlagen direkt der passenden Immobilie zu.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon-badge">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="badge-icon"
                >
                  <path
                    d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h3 className="benefit-card-title">Rendite verstehen</h3>
              <p className="benefit-card-description">
                Erkenne, wie Wertentwicklung und Einnahmen zur Performance deines Portfolios beitragen.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon-badge">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="badge-icon"
                >
                  <path
                    d="M17 16.5C17 16.7761 16.7762 17 16.5 17H3.5C3.38989 16.9999 3.29333 16.957 3.21069 16.8965C3.0863 16.8056 3.00012 16.6657 3 16.5V3.5C3 3.22382 3.22388 3 3.5 3C3.77612 3 4 3.22382 4 3.5V16H16.5C16.7762 16 17 16.2239 17 16.5ZM7.5 14C7.77612 14 8 13.7762 8 13.5V10.5C7.99963 10.2243 7.77576 10.0002 7.5 10C7.22418 10.0002 7.00031 10.2243 7 10.5V13.5C7 13.7762 7.22388 14 7.5 14ZM11.5 14C11.7761 14 12 13.7762 12 13.5V6.5C11.9996 6.2243 11.7758 6.00018 11.5 6C11.2242 6.00018 11.0003 6.2243 11 6.5V13.5C11 13.7762 11.2239 14 11.5 14ZM15.5 14C15.7761 14 16 13.7762 16 13.5V3.5C15.9996 3.2243 15.7758 3.00018 15.5 3C15.2242 3.00018 15.0003 3.2243 15 3.5V13.5C15 13.7762 15.2239 14 15.5 14Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h3 className="benefit-card-title">Mit deinem Portfolio wachsen</h3>
              <p className="benefit-card-description">
                Von der ersten Eigentumswohnung bis zum umfangreichen Immobilienportfolio.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default LandingPage;
